import { createSlice } from "@reduxjs/toolkit";
import {
  addProduct,
  addProductToImportList,
  getAllProducts,
  getImportListProducts,
  getLiveProducts,
  getProduct,
  getProductsByUser,
  getShopifyCollection,
  importProductToShopify,
  updateProduct,
} from "../../api/product";

const initialState = {
  isLoading: false,
  isSuccess: false,
  productInfo: [],
  liveProducts: [],
  importListProducts: [],
  updatedProduct: {},
  updatedVariants: [],
  pushToShopify: [],
  imageList: [],
  variantList: [],
  productDetails: [],
  updateProductDetails: {},
  shopifyCollections: [],
  rowIdWithImageUrl: {},
  uploadedImageWithRowId: [],
  persistedVariants: [],
  cellModifiedRow: [],
  isProductUpdated: false,
  productTabValue:0,
  productsByUser:null,
  admin_note:''
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    getUpdatedProductInfo: (state, { payload }) => {
      state.updatedProduct = payload;
    },
    updateItemforShopify: (state, { payload }) => {
      state.pushToShopify = payload;
    },
    remove: (state, { payload }) => {
      state.updatedProduct = null;
      state.updatedVariants = [];
    },

    getUpdatedVariants: (state, { payload }) => {
      state.updatedVariants = payload;
    },
    getImageList: (state, { payload }) => {
      state.imageList = payload;
    },
    getVariantList: (state, { payload }) => {
      state.variantList = payload;
    },
    getProductDetailsToAdd: (state, { payload }) => {
      state.productDetails = payload;
    },
    getProductDetailsForUpdate: (state, { payload }) => {
      state.updateProductDetails = payload;
    },
    getRowIdWithImageUrl: (state, { payload }) => {
      state.rowIdWithImageUrl = payload;
    },
    getUploadedImageWithRowId: (state, { payload }) => {
      state.uploadedImageWithRowId = payload;
    },
    getAdminVariantsPersisted: (state, { payload }) => {
      state.persistedVariants = payload;
    },
    getCellModifiedRow: (state, { payload }) => {
      state.cellModifiedRow = payload;
    },
    isProductUpdated: (state, { payload }) => {
      state.isProductUpdated = payload;
    },
    setProductTabValue:(state, { payload }) => {
      state.productTabValue = payload;
    },
    setAdminNotes:(state, { payload }) => {
      state.admin_note = payload;
    }
  },
  extraReducers: {
    [getAllProducts.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllProducts.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.productInfo = payload;
    },
    [getAllProducts.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [getProductsByUser.pending]: (state) => {
      state.isLoading = true;
    },
    [getProductsByUser.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.productsByUser = payload;
    },
    [getProductsByUser.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [getProduct.pending]: (state) => {
      state.isLoading = true;
    },
    [getProduct.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.productInfo = payload;
    },
    [getProduct.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.productInfo = payload;
    },
    // Only the latest request counts: a slow answer for an older search must not overwrite a newer one.
    [getLiveProducts.pending]: (state, { meta }) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.liveProductsRequestId = meta.requestId;
    },
    [getLiveProducts.fulfilled]: (state, { payload, meta }) => {
      if (meta.requestId !== state.liveProductsRequestId) return;
      state.isLoading = false;
      state.isSuccess = true;
      state.liveProducts = payload;
    },
    [getLiveProducts.rejected]: (state, { meta }) => {
      if (meta.requestId !== state.liveProductsRequestId) return;
      state.isLoading = false;
    },
    [getShopifyCollection.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    },
    [getShopifyCollection.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.shopifyCollections = payload;
    },
    [getShopifyCollection.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [addProduct.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    },
    [addProduct.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [addProduct.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [updateProduct.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    },
    [updateProduct.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [updateProduct.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [addProductToImportList.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    },
    [addProductToImportList.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [addProductToImportList.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [getImportListProducts.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    },
    [getImportListProducts.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.importListProducts = payload;
    },
    [getImportListProducts.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [importProductToShopify.pending]: (state) => {
      state.isLoading = true;
    },
    [importProductToShopify.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [importProductToShopify.rejected]: (state, action) => {
      state.isLoading = false;
    },
  },
});
export const {
  getUpdatedProductInfo,
  remove,
  getUpdatedVariants,
  updateItemforShopify,
  getImageList,
  getVariantList,
  getProductDetailsToAdd,
  getProductDetailsForUpdate,
  getRowIdWithImageUrl,
  getUploadedImageWithRowId,
  getAdminVariantsPersisted,
  getCellModifiedRow,
  setProductTabValue,
  isProductUpdated,
  setAdminNotes
} = productSlice.actions;
export const productSelector = (state) => state?.product;
export default productSlice.reducer;
